import React from 'react';
import Link from '../components/LocalizedLink';

import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const TerminiPage = () => {
  const { t } = useTranslation();

  return (
    <div data-testid="termini-page" className="py-16 md:py-24 bg-[var(--color-bg)] min-h-screen">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <Link 
          to="/" 
          className="inline-flex items-center text-[var(--color-primary)] hover:underline mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          {t('common.torna_home')}
        </Link>

        <h1 className="text-4xl font-extrabold tracking-tight text-[var(--color-text)] mb-8">
          {t('termini.title')}
        </h1>

        <div className="card-elevated p-8 md:p-12 space-y-8">
          <p className="text-lg text-[var(--color-text-muted)]">{t('termini.updated')}</p>

          <section>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-4">{t('termini.s1_title')}</h2>
            <p className="text-[var(--color-text-muted)] leading-relaxed">{t('termini.s1_text')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-4">{t('termini.s2_title')}</h2>
            <p className="text-[var(--color-text-muted)] mb-4 leading-relaxed">{t('termini.s2_text')}</p>
            <ul className="list-disc pl-6 text-[var(--color-text-muted)] space-y-2">
              <li>{t('termini.s2_1')}</li>
              <li>{t('termini.s2_2')}</li>
              <li>{t('termini.s2_3')}</li>
              <li>{t('termini.s2_4')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-4">{t('termini.s3_title')}</h2>
            <h3 className="text-xl font-semibold text-[var(--color-text)] mb-2">{t('termini.s3_1_title')}</h3>
            <p className="text-[var(--color-text-muted)] mb-4 leading-relaxed">{t('termini.s3_1_text')}</p>
            <h3 className="text-xl font-semibold text-[var(--color-text)] mb-2">{t('termini.s3_2_title')}</h3>
            <p className="text-[var(--color-text-muted)] leading-relaxed">{t('termini.s3_2_text')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-4">{t('termini.s4_title')}</h2>
            <ul className="list-disc pl-6 text-[var(--color-text-muted)] space-y-2">
              <li>{t('termini.s4_1')}</li>
              <li>{t('termini.s4_2')}</li>
              <li>{t('termini.s4_3')}</li>
              <li>{t('termini.s4_4')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-4">{t('termini.s5_title')}</h2>
            <p className="text-[var(--color-text-muted)] mb-4 leading-relaxed">
              <strong className="text-[var(--color-text)]">{t('termini.s5_p1_bold')}</strong> {t('termini.s5_p1_text')}
            </p>
            <p className="text-[var(--color-text-muted)] leading-relaxed">
              <strong className="text-[var(--color-text)]">{t('termini.s5_p2_bold')}</strong> {t('termini.s5_p2_text')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-4">{t('termini.s6_title')}</h2>
            <ul className="list-disc pl-6 text-[var(--color-text-muted)] space-y-2">
              <li>{t('termini.s6_1')}</li>
              <li>{t('termini.s6_2')}</li>
              <li>{t('termini.s6_3')}</li>
              <li>{t('termini.s6_4')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-4">{t('termini.s7_title')}</h2>
            <p className="text-[var(--color-text-muted)] mb-4 leading-relaxed">{t('termini.s7_text')}</p>
            <ul className="list-disc pl-6 text-[var(--color-text-muted)] space-y-2">
              <li>{t('termini.s7_1')}</li>
              <li>{t('termini.s7_2')}</li>
              <li>{t('termini.s7_3')}</li>
            </ul>
            <p className="text-[var(--color-text-muted)] mt-4 leading-relaxed">{t('termini.s7_note')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-4">{t('termini.s8_title')}</h2>
            <p className="text-[var(--color-text-muted)] leading-relaxed">{t('termini.s8_text')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-4">{t('termini.s9_title')}</h2>
            <p className="text-[var(--color-text-muted)] leading-relaxed">{t('termini.s9_text')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-4">{t('termini.s10_title')}</h2>
            <p className="text-[var(--color-text-muted)] leading-relaxed">{t('termini.s10_text')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-4">{t('termini.s11_title')}</h2>
            <p className="text-[var(--color-text-muted)] leading-relaxed">
              {t('termini.s11_text')}
              <a href="mailto:info@faccioapp.it" className="text-[var(--color-primary)] hover:underline ml-1">info@faccioapp.it</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TerminiPage;
